export default __webpack_public_path__ + "static/media/banner-01.ac9c446f.png";